import { sessionStorageHelper } from '../storage'

export const getSDKConfig = (instanceId: string) => {
  const storage = sessionStorageHelper(`__klarna_sdk-${instanceId}-config`)
  return storage.get('config')
}
